<template>
  <div class="pt-5rem">
    <PrimeExpand />


    <div v-show="isPageReady">
      <AppHeader />

      <slot />
    </div>
    <LoadingAllpage v-show="!isPageReady"></LoadingAllpage>
    <AppFooter />
    <AppTabMenu />
  </div>
</template>
<script setup>
  const isPageReady = ref(true);
  const nuxtApp = useNuxtApp();
  const darkMode = useCookie('theme');

  function showPage() {
    isPageReady.value = true;
  }

  nuxtApp.hook('page:finish', () => {
    if (!import.meta.client) {
      return;
    }

    const isDarkModePreferred = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (darkMode.value === null) {
      darkMode.value = isDarkModePreferred;
    } else if (darkMode.value) {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
    }
    showPage();
  });
</script>
